
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class RipplePoolsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (400 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        
        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = this.pseudoRandom(x) * spacing;
                const offY = this.pseudoRandom(y) * spacing;
                const rings = Math.floor(4 * (config.parallaxComplexity || 1.0));
                
                const draw = () => {
                    for (let j = 0; j < rings; j++) {
                        const r = ((curTime + j * 0.5) % 2) * 100 * scale;
                        const opacity = 1 - (r / (200 * scale));
                        
                        ctx.save();
                        ctx.globalAlpha *= Math.max(0, opacity);
                        ctx.lineWidth = (2 / layerIndex) * scale;
                        ctx.beginPath();
                        ctx.arc(x + offX, y + offY, r, 0, Math.PI * 2);
                        ctx.stroke();
                        ctx.restore();
                    }
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
